import React, { Fragment, useContext, useEffect } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { ENV_COOKIE_LOGIN_NAME } from "../../../config/envVars";
import { useParams } from "react-router-dom";

export default function AuthLayer(props) {
  const { loanId } = useParams();
  const {
    state: { loading, authentication, token, tokenToSet, loggedOut },
    dispatch,
  } = useContext(AuthContext);

  useEffect(() => {
    checkLocalTokenAndResetCredentials();
  }, []);

  useEffect(() => {
    checkTokenToSet();
  });

  let showContent = false;
  if (token) {
    showContent = true;
  }

  let isLocalStorageTokenSet = localStorage.getItem(ENV_COOKIE_LOGIN_NAME);
  if (isLocalStorageTokenSet) {
    showContent = true;
  }

  const checkLocalTokenAndResetCredentials = () => {
    const queryParams = new URLSearchParams(location.search);
    const queryParamsLoanId = queryParams.get("lid");
    const lid = loanId || queryParamsLoanId;

    if (!lid) return;

    let localStorageAuthToken = localStorage.getItem(ENV_COOKIE_LOGIN_NAME);
    localStorageAuthToken = JSON.parse(localStorageAuthToken);
    const localStorageLoanId = localStorageAuthToken?.lid;

    if (localStorageLoanId === lid) {
      dispatch({
        type: "UPDATE_AUTH_CONTEXT",
        payload: { authentication: true },
      });
    } else if (authentication === undefined && !loading) {
      dispatch({
        type: "REQUEST_POST_SESSION_TOKEN",
        payload: {
          lid,
        },
      });
    }
  };

  const checkTokenToSet = () => {
    if (tokenToSet && !token && !loading) {
      dispatch({
        type: "SET_TOKEN",
        payload: { tokenToSet },
      });
    }
  };

  if (loggedOut) return <Fragment />;

  return (
    <Fragment>{showContent && <Fragment>{props.children}</Fragment>}</Fragment>
  );
}
